import { listAWSGateways } from './AWS_Gateways/list';
import { geDeviceMetrics } from '../NetworkSystem/Metrics/getDeviceMetrics';
import { geGatewayMetrics } from '../NetworkSystem/Metrics/getGatewayMetrics';
import { geLNSMetrics } from '../NetworkSystem/Metrics/getLNSMetrics';
/**
 * **Network DAO**
 */
export const NetWorkDAO = {
    geLNSMetricsFromTimestream: geLNSMetrics,
    geDeviceMetricsFromTimestream: geDeviceMetrics,
    geGatewayMetricsFromTimestream: geGatewayMetrics,
    gateway: {
        AWS: {
            list: listAWSGateways
        }
    }
};
